module.exports = __webpack_public_path__ + "img/武汉奇佶医疗.212850a.png";